<template>
  <div id="Manage">
    <!-- 订单管理   住宿订单 -->
    <!-- Dialog 对话框 增加、编辑-->
    <el-dialog :title="dialogFonfig.openType === 'add' ? dialogFonfig.addName : dialogFonfig.editName"
               :close-on-click-modal="false"
               :visible.sync="dialogFonfig.isShowDialogVisible"
               @close="clickCancelData">
      <CommonTabForm :form="openForm"
                     :tabLabel.sync="tabFormLabel"
                     :tableData="priceDate"
                     :activeTabName.sync="activeTabName"
                     @tabHandleClick="swichTab"
                     ref="elTable"></CommonTabForm>

      <div slot="footer"
           class="dialog-footer">
        <el-button @click="clickCancelData">取 消</el-button>
        <el-button type="primary"
                   @click="clickSubmitData(openForm)">{{dialogBtnName}}</el-button>
      </div>
    </el-dialog>
    <!-- Dialog 对话框 审核表单-->
    <el-dialog :title="dialogFonfigAudit.auditName"
               class="dialogAudit"
               :close-on-click-modal="false"
               :visible.sync="dialogFonfigAudit.isShowDialogVisible">
      <CommonForm :form="auditForm"
                  class="dialogAuditForm"
                  :formLabel="auditFormLabel"
                  inline></CommonForm>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="clickCancelData">取 消</el-button>
        <el-button type="danger"
                   @click="clickSubmitAuditData(0, auditForm)">驳 回</el-button>
        <el-button type="success"
                   @click="clickSubmitAuditData(1, auditForm)">通 过</el-button>
      </div>
    </el-dialog>

    <!-- Dialog 对话框 备注表单-->
    <el-dialog :title="dialogFonfigRemarks.remarksName"
               class="dialogAudit"
               :close-on-click-modal="false"
               :visible.sync="dialogFonfigRemarks.isShowDialogVisible">
      <CommonForm :form="remarksForm"
                  class="dialogAuditForm"
                  :formLabel="remarksFormLabel"
                  inline></CommonForm>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="clickCancelData">取 消</el-button>
        <el-button type="success"
                   @click="clickSubmitRemarksData(remarksForm)">确 认</el-button>
      </div>
    </el-dialog>

    <!-- Dialog 对话框 拒绝表单-->
    <el-dialog :title="dialogFonfigRefund.refundName"
               class="dialogAudit"
               :close-on-click-modal="false"
               :visible.sync="dialogFonfigRefund.isShowDialogVisible">
      <CommonForm :form="refundForm"
                  class="dialogAuditForm"
                  :formLabel="refundFormLabel"
                  inline></CommonForm>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="clickCancelData">取 消</el-button>
        <el-button type="success"
                   @click="clickSubmitRefundData(refundForm)">确 认</el-button>
      </div>
    </el-dialog>
    <CommonManageMain>
      <template v-slot:header>
        <div>
          <!-- <el-button type="primary"
                     size="small"
                     icon="el-icon-circle-plus-outline">添加酒店/民宿</el-button> -->
          <!-- <el-button type="danger" size="small" @click="clickDelData" icon="el-icon-delete">删除</el-button> -->
        </div>
        <CommonForm :form="searchForm"
                    :formLabel="searchformLabel"
                    ref="select"
                    class="filtrateInput">
          <el-button type="primary"
                     @click="searchHotelProductToAudit(searchForm)">搜 索</el-button>
          <el-button>导出</el-button>
          <el-button type="text">查看已导出列表</el-button>
          <el-button type="text"
                     @click="resetFilter(searchForm)">重置筛选条件</el-button>
        </CommonForm>

      </template>

      <!-- 表格内容框 -->
      <template v-slot:content>
        <CommonTabForm class="content"
                       :tabLabel="tableFormLabel"
                       :tableData="tableData"
                       @clickEditData="clickEditData"
                       @clickInfoData='clickInfoData'
                       @clickWarningData='clickAuditData'
                       @clickRemarks='clickRemarks'
                       @addSubcategory='clickImplement'
                       @clickDeleteData='clickRefuseData'
                       @tabHandleClick="swichTable"
                       @getPage="getPage"></CommonTabForm>
      </template>
    </CommonManageMain>
  </div>
</template>

<script>
import {
  getHotelOrder, getHotelOrderDetail, confirmHotelOrder
  , AuditHotelOrder, RemarkHotelOrder, implementHotelOrder
} from 'api/orderManagement'
import {
  getTourOrder, getTourOrderDetail, confirmTourOrder
} from 'api/orderManagement'




import CommonForm from 'components/CommonForm.vue'
import CommonTable from 'components/CommonTable.vue'
import CommonManageMain from 'components/CommonManageMain.vue'
import CommonTabForm from 'components/CommonTab_Form.vue'
import CommonAmap from 'components/CommonAmap.vue'


export default {
  components: {
    CommonForm,
    CommonTable,
    CommonManageMain,
    CommonTabForm,
    CommonAmap
  },
  data () {
    return {
      //主页面组件布局
      imgIndex: [],//获取删除后的图片
      priceDate: [],//第二页中价格数据的数据
      tabIndex: 0,//存放tab标签页的下标
      searchData: '',//存放搜索的数据，分页时使用
      tableFormLabel: [
        {
          name: 'first',
          label: "待支付",
          type: 'table',
          tableLabel: [
            {
              prop: 'order_no',
              label: '订单编号',
              width: '150px'
            },
            {
              prop: 'order_title',
              label: '订单信息',
              width: '200px',
            },
            {
              prop: 'source',
              label: '来源渠道',
            },
            {
              prop: 'name',
              label: '联系人'
            },
            {
              prop: 'phone',
              label: '联系方式'
            },
            {
              prop: 'order_status',
              label: '订单状态',
              type: 'stateOrder'
            },
            {
              prop: 'create_time',
              label: '下单时间',
              width: '200px'
            },
            {
              prop: 'total_price',
              label: '订单总额',
            },
            {
              prop: 'real_sum',
              label: '支付金额',
            },
            {
              prop: 'pay_type',
              label: '支付方式',
              type: 'stateOrderpay',
            },
            {
              prop: 'operation',
              label: '操作',
              width: '75px',
              type: 'operation',
              children: [
                {
                  content: '详情',
                  type: 'primary'
                },
              ]
            }
          ],
          tableConfig: {
            isShowLoading: true,
            // 改造状态列显示效果 el-switch
            page: 1,
            total: 30,
            // 加载状态
            loading: true,
            // 显示 选择多行数据
            selection: true,
            //显示表格top按钮
            isShowTopBtn: true,
          }
        },
        {
          name: 'second',
          label: "已支付",
          type: 'table',
          tableLabel: [
            {
              prop: 'order_no',
              label: '订单编号',
              width: '150px'
            },
            {
              prop: 'order_title',
              label: '订单信息',
              width: '200px',
            },
            {
              prop: 'source',
              label: '来源渠道',
            },
            {
              prop: 'name',
              label: '联系人'
            },
            {
              prop: 'phone',
              label: '联系方式'
            },
            {
              prop: 'order_status',
              label: '订单状态',
              type: 'stateOrder'
            },
            {
              prop: 'create_time',
              label: '下单时间',
              width: '200px'
            },
            {
              prop: 'total_price',
              label: '订单总额',
            },
            {
              prop: 'real_sum',
              label: '支付金额',
            },
            {
              prop: 'pay_type',
              label: '支付方式',
              type: 'stateOrderpay',
            },
            {
              prop: 'operation',
              label: '操作',
              width: '115px',
              type: 'operation',
              children: [
                {
                  content: '拒绝',
                  type: 'danger'
                },
                {
                  content: '确认',
                  type: 'info'
                },
                {
                  content: '详情',
                  type: 'primary'
                },
                {
                  content: '备注',
                  type: 'remarks'
                },
              ]
            }
          ],
          tableConfig: {
            isShowLoading: true,
            // 改造状态列显示效果 el-switch
            page: 1,
            total: 30,
            // 加载状态
            loading: true,
            // 显示 选择多行数据
            selection: true,
            //显示表格top按钮
            isShowTopBtn: true,
          }
        },
        {
          name: 'third',
          label: "已确认",
          type: 'table',
          tableLabel: [
            {
              prop: 'order_no',
              label: '订单编号',
              width: '150px'
            },
            {
              prop: 'order_title',
              label: '订单信息',
              width: '200px',
            },
            {
              prop: 'source',
              label: '来源渠道',
            },
            {
              prop: 'name',
              label: '联系人'
            },
            {
              prop: 'phone',
              label: '联系方式'
            },
            {
              prop: 'order_status',
              label: '订单状态',
              type: 'stateOrder'
            },
            {
              prop: 'create_time',
              label: '下单时间',
              width: '200px'
            },
            {
              prop: 'total_price',
              label: '订单总额',
            },
            {
              prop: 'real_sum',
              label: '支付金额',
            },
            {
              prop: 'pay_type',
              label: '支付方式',
              type: 'stateOrderpay'
            },
            {
              prop: 'operation',
              label: '操作',
              width: '100px',
              type: 'operation',
              children: [
                {
                  content: '入住',
                  type: 'addSub'
                },
                {
                  content: '详情',
                  type: 'primary'
                },
                {
                  content: '备注',
                  type: 'remarks'
                },
              ]
            }
          ],
          tableConfig: {
            isShowLoading: true,
            // 改造状态列显示效果 el-switch
            page: 1,
            total: 30,
            // 加载状态
            loading: true,
            // 显示 选择多行数据
            selection: true,
            //显示表格top按钮
            isShowTopBtn: true,
          }
        },
        {
          name: 'fourth',
          label: "已出行",
          type: 'table',
          tableLabel: [
            {
              prop: 'order_no',
              label: '订单编号',
              width: '150px'
            },
            {
              prop: 'order_title',
              label: '订单信息',
              width: '200px',
            },
            {
              prop: 'source',
              label: '来源渠道',
            },
            {
              prop: 'name',
              label: '联系人'
            },
            {
              prop: 'phone',
              label: '联系方式'
            },
            {
              prop: 'order_status',
              label: '订单状态',
              type: 'stateOrder'
            },
            {
              prop: 'create_time',
              label: '下单时间',
              width: '200px'
            },
            {
              prop: 'total_price',
              label: '订单总额',
            },
            {
              prop: 'real_sum',
              label: '支付金额',
            },
            {
              prop: 'pay_type',
              label: '支付方式',
              type: 'stateOrderpay'
            },
            {
              prop: 'operation',
              label: '操作',
              width: '90px',
              type: 'operation',
              children: [
                {
                  content: '详情',
                  type: 'primary'
                },
                {
                  content: '备注',
                  type: 'remarks'
                },
              ]
            }
          ],
          tableConfig: {
            isShowLoading: true,
            // 改造状态列显示效果 el-switch
            page: 1,
            total: 30,
            // 加载状态
            loading: true,
            // 显示 选择多行数据
            selection: true,
            //显示表格top按钮
            isShowTopBtn: true,
          }
        },
        {
          name: 'fifth',
          label: "已评价",
          type: 'table',
          tableLabel: [
            {
              prop: 'order_no',
              label: '订单编号',
              width: '150px'
            },
            {
              prop: 'order_title',
              label: '订单信息',
              width: '200px',
            },
            {
              prop: 'source',
              label: '来源渠道',
            },
            {
              prop: 'name',
              label: '联系人'
            },
            {
              prop: 'phone',
              label: '联系方式'
            },
            {
              prop: 'order_status',
              label: '订单状态',
              type: 'stateOrder'
            },
            {
              prop: 'create_time',
              label: '下单时间',
              width: '200px'
            },
            {
              prop: 'total_price',
              label: '订单总额',
            },
            {
              prop: 'real_sum',
              label: '支付金额',
            },
            {
              prop: 'pay_type',
              label: '支付方式',
              type: 'stateOrderpay'
            },
            {
              prop: 'operation',
              label: '操作',
              width: '90px',
              type: 'operation',
              children: [
                {
                  content: '详情',
                  type: 'primary'
                },
                {
                  content: '备注',
                  type: 'remarks'
                },
              ]
            }
          ],
          tableConfig: {
            isShowLoading: true,
            // 改造状态列显示效果 el-switch
            page: 1,
            total: 30,
            // 加载状态
            loading: true,
            // 显示 选择多行数据
            selection: true,
            //显示表格top按钮
            isShowTopBtn: true,
          }
        },
        {
          name: 'sixth',
          label: "退款中",
          type: 'table',
          tableLabel: [
            {
              prop: 'order_no',
              label: '订单编号',
              width: '150px'
            },
            {
              prop: 'order_title',
              label: '订单信息',
              width: '200px',
            },
            {
              prop: 'source',
              label: '来源渠道',
            },
            {
              prop: 'name',
              label: '联系人'
            },
            {
              prop: 'phone',
              label: '联系方式'
            },
            {
              prop: 'order_status',
              label: '订单状态',
              type: 'stateOrder'
            },
            {
              prop: 'create_time',
              label: '下单时间',
              width: '200px'
            },
            {
              prop: 'total_price',
              label: '订单总额',
            },
            {
              prop: 'real_sum',
              label: '支付金额',
            },
            {
              prop: 'pay_type',
              label: '支付方式',
              type: 'stateOrderpay'
            },
            {
              prop: 'operation',
              label: '操作',
              width: '100px',
              type: 'operation',
              children: [
                {
                  content: '审核',
                  type: 'warning'
                },
                {
                  content: '详情',
                  type: 'primary'
                },
                {
                  content: '备注',
                  type: 'remarks'
                },
              ]
            }
          ],
          tableConfig: {
            isShowLoading: true,
            // 改造状态列显示效果 el-switch
            page: 1,
            total: 30,
            // 加载状态
            loading: true,
            // 显示 选择多行数据
            selection: true,
            //显示表格top按钮
            isShowTopBtn: true,
          }
        },
        {
          name: 'seventh',
          label: "已退款",
          type: 'table',
          tableLabel: [
            {
              prop: 'order_no',
              label: '订单编号',
              width: '150px'
            },
            {
              prop: 'order_title',
              label: '订单信息',
              width: '200px',
            },
            {
              prop: 'source',
              label: '来源渠道',
            },
            {
              prop: 'name',
              label: '联系人'
            },
            {
              prop: 'phone',
              label: '联系方式'
            },
            {
              prop: 'order_status',
              label: '订单状态',
              type: 'stateOrder'
            },
            {
              prop: 'create_time',
              label: '下单时间',
              width: '200px'
            },
            {
              prop: 'total_price',
              label: '订单总额',
            },
            {
              prop: 'real_sum',
              label: '支付金额',
            },
            {
              prop: 'pay_type',
              label: '支付方式',
              type: 'stateOrderpay'
            },
            {
              prop: 'operation',
              label: '操作',
              width: '90px',
              type: 'operation',
              children: [
                {
                  content: '详情',
                  type: 'primary'
                },
                {
                  content: '备注',
                  type: 'remarks'
                },
              ]
            }
          ],
          tableConfig: {
            isShowLoading: true,
            // 改造状态列显示效果 el-switch
            page: 1,
            total: 30,
            // 加载状态
            loading: true,
            // 显示 选择多行数据
            selection: true,
            //显示表格top按钮
            isShowTopBtn: true,
          }
        },
        {
          name: 'eighth',
          label: "已取消",
          type: 'table',
          tableLabel: [
            {
              prop: 'order_no',
              label: '订单编号',
              width: '150px'
            },
            {
              prop: 'order_title',
              label: '订单信息',
              width: '200px',
            },
            {
              prop: 'source',
              label: '来源渠道',
            },
            {
              prop: 'name',
              label: '联系人'
            },
            {
              prop: 'phone',
              label: '联系方式'
            },
            {
              prop: 'order_status',
              label: '订单状态',
              type: 'stateOrder'
            },
            {
              prop: 'create_time',
              label: '下单时间',
              width: '200px'
            },
            {
              prop: 'total_price',
              label: '订单总额',
            },
            {
              prop: 'real_sum',
              label: '支付金额',
            },
            {
              prop: 'pay_type',
              label: '支付方式',
              type: 'stateOrderpay'
            },
            {
              prop: 'operation',
              label: '操作',
              width: '90px',
              type: 'operation',
              children: [
                {
                  content: '详情',
                  type: 'primary'
                },
                {
                  content: '备注',
                  type: 'remarks'
                },
              ]
            }
          ],
          tableConfig: {
            isShowLoading: true,
            // 改造状态列显示效果 el-switch
            page: 1,
            total: 30,
            // 加载状态
            loading: true,
            // 显示 选择多行数据
            selection: true,
            //显示表格top按钮
            isShowTopBtn: true,
          }
        },

      ],

      //对话框 表单组件
      tabFormLabel: [
        {
          name: 'first',
          label: "订单信息",
          type: 'form',
          children: [ //form表单 组件   
            {
              model: 'id',
              label: '订单ID:',
              width: '366px',
              type: 'text'
            },
            {
              model: 'order_title',
              label: '订单标题:',
              width: '500px',
              type: 'text'
            },
            {
              model: 'order_no',
              label: '订单编号:',
              width: '366px',
              type: 'text'
            },
            {
              model: 'tour_id',
              label: '旅游ID:',
              width: '250px',
              type: 'text'
            },
            {
              model: 'user_id',
              label: '用户ID:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'source',
              label: '来源:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'supplier_id',
              label: '供应商ID:',
              width: '390px',
              type: 'text'
            },
            {
              model: 'share_user_id',
              label: '分享用户ID:',
              width: '250px',
              type: 'text'
            },
            {
              model: 'tour_days',
              label: '旅游天数:',
              width: '364px',
              type: 'text'
            },
            {
              model: 'tour_adult_num',
              label: '成人数:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'departure_date',
              label: '出发日期:',
              width: '364px',
              type: 'text'
            },
            {
              model: 'tour_kid_num',
              label: '儿童数:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'departure_city',
              label: '出发城市:',
              width: '391px',
              type: 'text'
            },
            {
              model: 'tour_price_id',
              label: '旅游价格ID:',
              width: '250px',
              type: 'text'
            },
            {
              model: 'departure_site',
              label: '出发地点:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'price',
              label: '价格:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'settlement_price',
              label: '结算价格:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'cost',
              label: '成本:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'kid_price',
              label: '儿童价格:',
              width: '376px',
              type: 'text'
            },
            {
              model: 'kid_cost',
              label: '儿童成本:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'integral_price',
              label: '积分价格:',
              width: '402px',
              type: 'text'
            },
            {
              model: 'kid_settlement_price',
              label: '儿童结算成本:',
              width: '250px',
              type: 'text'
            },
            {
              model: 'rate',
              label: '分润比例:',
              width: '402px',
              type: 'text'
            },
            {
              model: 'kid_rate',
              label: '儿童分润比例:',
              width: '250px',
              type: 'text'
            },
            {
              model: 'order_type',
              label: '订单类型:',
              width: '373px',
              type: 'text'
            },
            {
              model: 'order_status',
              label: '订单状态:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'chg_amount',
              label: '优惠金额:',
              width: '344px',
              type: 'text'
            },
            {
              model: 'total_price',
              label: '供货价:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'real_sum',
              label: '实额:',
              width: '344px',
              type: 'text'
            },
            {
              model: 'balance',
              label: '余额:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'tour_amount',
              label: '旅游金额:',
              width: '344px',
              type: 'text'
            },
            {
              model: 'integral',
              label: '积分:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'coupon_ids',
              label: '优惠券ID:',
              width: '385px',
              type: 'text'
            },
            {
              model: 'cash_coupon_sum',
              label: '现金券金额:',
              width: '250px',
              type: 'text'
            },
            {
              model: 'pay_type',
              label: '支付类型:',
              width: '371px',
              type: 'text'
            },
            {
              model: 'pay_time',
              label: '支付时间:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'admin_id',
              label: '管理员ID:',
              width: '342px',
              type: 'text'
            },
            {
              model: 'pay_money',
              label: '付款:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'check_time',
              label: '检查时间:',
              width: '368px',
              type: 'text'
            },
            {
              model: 'finish_time',
              label: '完成时间:',
              width: '350px',
              type: 'text'
            },
            {
              model: 'pay_trade_no',
              label: '付款交易编号:',
              width: '368px',
              type: 'text'
            },
            {
              model: 'create_time',
              label: '创建时间:',
              width: '350px',
              type: 'text'
            },
          ]
        },
        {
          name: 'second',
          label: "用户信息",
          type: 'table',
          //tab-table表单数据
          formTable: {
            name: '',
            nickname: '',
            referrer_uid: '',
            facilitator_id: '',
            phone: '',
          },
          tableLabel: [
            {
              prop: 'name',
              label: '姓名',
              width: '140px'
            },
            {
              prop: 'nickname',
              label: '简称',
            },
            {
              prop: 'referrer_uid',
              label: '证件类型',
              width: '140px'
            },
            {
              prop: 'facilitator_id',
              label: '证件号码',
              width: '140px'
            },
            {
              prop: 'phone',
              label: '手机号码',
              width: '140px'
            },
          ],
          tableConfig: {
            isShowLoading: false,
            // 改造状态列显示效果 el-switch
            page: 1,
            total: 30,
            // 加载状态
            loading: false,
            // 显示 选择多行数据
            selection: false,
            //row key
            rowKey: 'date',
            //显示表格top按钮
            isShowTopBtn: false,
          }
        },
        {
          name: 'third',
          label: "线路信息",
          type: 'form',
          children: [
            {
              model: 'id',
              label: 'ID:',
              width: '273px',
              type: 'text'
            },
            {
              model: 'name',
              label: '名称:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'code_no',
              label: '订单编号:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'product_pic',
              label: '产品图片:',
              type: 'upload'
            },
            {
              model: 'group_mode',
              label: '组团模式:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'transport',
              label: '出行交通:',
              width: '300px',
              type: 'text'
            },
          ]
        },
        {
          name: 'fourth',
          label: "渠道来源",
          type: 'form',
          children: [
            {
              model: 'sourceId',
              label: 'ID:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'sourcePhone',
              label: '负责人电话:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'sourceNickname',
              label: '全称:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'sourceName',
              label: '负责人姓名:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'sourceAbbreviation',
              label: '简称:',
              width: '287px',
              type: 'text'
            },
            {
              model: 'sourceTelephone',
              label: '手机号码:',
              width: '300px',
              type: 'text'
            },
          ]
        },
        {
          name: 'fifth',
          label: '供应商',
          type: 'form',
          children: [
            {
              model: 'id',
              label: 'ID:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'name',
              label: '负责人名称:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'nickname',
              label: '全称:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'phone',
              label: '负责人电话:',
              width: '300px',
              type: 'text'
            },
            {
              model: 'abbreviation',
              label: '简称:',
              width: '287px',
              type: 'text'
            },
            {
              model: 'telephone',
              label: '手机号码:',
              width: '300px',
              type: 'text'
            },
          ]
        },

      ],

      // 对话框 Dialog 基础数据
      dialogFonfig: {
        openType: 'add',
        addName: '查看订单详情',
        editName: '查看订单详情',
        isShowDialogVisible: false
      },
      // 对话框 Dialog 审核住宿订单
      dialogFonfigAudit: {
        auditName: '待审核',
        isShowDialogVisible: false
      },

      //form表单 审核
      auditForm: {
        order_no: '',
        remarks: ''
      },
      auditFormLabel: [
        {
          model: 'order_no',
          label: '订单编号',
          width: '400px',
          type: 'disabled'
        },
        {
          model: 'remarks',
          label: '审核理由',
          type: 'textarea',
          width: '600px',
          required: true
        },
      ],

      // 对话框 Dialog 备注 住宿订单
      dialogFonfigRemarks: {
        remarksName: '备注',
        isShowDialogVisible: false
      },
      //form表单 备注
      remarksForm: {
        order_no: '',
        remarks: ''
      },

      remarksFormLabel: [
        {
          model: 'order_no',
          label: '订单编号',
          width: '400px',
          type: 'disabled'
        },
        {
          model: 'remarks',
          label: '备注',
          type: 'textarea',
          width: '600px',
          required: true
        },
      ],

      // 对话框 Dialog 备注 住宿订单
      dialogFonfigRefund: {
        refundName: '拒绝',
        isShowDialogVisible: false
      },
      //form表单 备注
      refundForm: {
        order_no: '',
        refund: ''
      },

      refundFormLabel: [
        {
          model: 'order_no',
          label: '订单编号',
          width: '400px',
          type: 'disabled'
        },
        {
          model: 'remarks',
          label: '备注',
          type: 'textarea',
          width: '600px',
          required: true
        },
      ],

      //form表单 基础数据
      openForm: {
        //订单信息
        id: "",
        order_no: "",
        order_title: "",
        user_id: "",
        share_user_id: "",
        source: "",
        supplier_id: "",
        tour_id: "",
        tour_days: "",
        tour_adult_num: "",
        tour_kid_num: "",
        departure_date: "",
        departure_city: "",
        departure_site: "",
        tour_price_id: "",
        tour_price_data: {//价格数据
          pric: "",
          cost: "",
          settlement_price: "",
          kid_price: "",
          kid_cost: "",
          kid_settlement_price: "",
          integral_price: "",
          rate: "",
          kid_rate: ""
        },
        tour_friend_data: "",
        remarks: "",
        real_name: "",
        mobile: "",
        order_type: "",
        order_status: "",
        total_price: "",
        chg_amount: "",
        real_sum: "",
        balance: "",
        tour_amount: "",
        integral: "",
        cash_coupon_sum: "",
        coupon_ids: "",
        pay_type: "",
        pay_time: "",
        pay_trade_no: "",
        pay_money: "",
        check_time: "",
        finish_time: "",
        cancel_time: "",
        cancel_reason: "",
        refund_time: "",
        refund_money: "",
        refund_reason: "",
        create_time: "",
        admin_id: "",
        //用户信息
        name: '',
        nickname: '',
        referrer_uid: '',
        facilitator_id: '',
        phone: '',
        //线路信息
        id: "",
        name: "",
        code_no: "",
        product_pic: "",
        travel_mode: "",
        group_mode: "",
        transport: "",
        //渠道来源
        sourceId: "",
        sourceAbbreviation: "",
        sourceNickname: "",
        sourceTelephone: "",
        sourceName: "",
        sourcePhone: "",
        //供应商信息
        id: "",
        abbreviation: "",
        nickname: "",
        telephone: "",
        name: "",
        phone: ""
      },
      // form表单 搜索数据
      searchForm: {
        order_no: '',
        order_title: '',
        username: '',
        mobile: '',
        supplier_id: '',
        pay_type: ''
      },
      searchformLabel: [
        {
          model: 'order_no',
          label: '订单编号',
          width: '304px',
        },
        {
          model: 'order_title',
          label: '订单信息',
          width: '304px',
        },
        {
          model: 'username',
          label: '联系人',
          width: '304px',
        },
        {
          model: 'mobile',
          label: '联系方式',
          width: '304px',
        },
        {
          model: 'supplier_id',
          label: '供应商ID',
          width: '304px',
        },
        {
          model: 'pay_type',
          label: '支付方式',
          type: 'select',
          width: '230px',
          options: [
            { value: 0, label: '余额' },
            { value: 1, label: '抵用金' },
            { value: 2, label: '积分' },
            { value: 3, label: '微信' },
            { value: 4, label: '支付宝' },
            { value: 5, label: '银联' },
          ]
        },
      ],
      //内层Dialog
      inDialog: {
        title: '选择经纬度',
        isShowDialogVisible: false
      },

      // table 表格 基础数据
      tableData: [],
      // 酒店、民宿-全部-数据
      hotelAllDataObj: {},
      // catgory_id最大值
      MaxId: '',
      //待审核 或 正式运营 Name
      activeTableName: 'first',
      //Dialog新增/编辑 Name
      activeTabName: 'first',
      //Dialog 放大图片
      dialogImgVisible: false,
      dialogImageUrl: '',

      //提交保存信息的 按钮名称
      dialogBtnName: '下一步'
    }
  },
  method: {
  },
  mounted () {
    //初始table数据
    this.getTourOrder();
  },
  watch: {
    //将字段转换为Elementui能用的字段
    hotelAllDataObj: function () {
      this.tableData = this.dataFormatDeal(
        this.hotelAllDataObj.list,
        {
          status: 'state',
        },
        0
      )
    },
    activeTabName: function () {
      if (this.activeTabName == "sixth") {
        this.dialogBtnName = '确认'
      } else {
        this.dialogBtnName = "下一步"
      }
    },
  },
  methods: {

    //住宿订单 请求接口
    getTourOrder (data) {
      if (data) {
        getTourOrder(data).then(res => {
          const DATA = res.data
          if (DATA.code == 200) {
            this.$message({
              message: DATA.message,
              type: 'success'
            })
            this.hotelAllDataObj = DATA.data

            this.tableFormLabel[this.tabIndex].tableConfig.total = DATA.data.total
            this.tableFormLabel[this.tabIndex].tableConfig.loading = false
            console.log(this.hotelAllDataObj)
          }

        })
      } else {
        getTourOrder({
          order_status: this.tabIndex,
          page: this.tableFormLabel[this.tabIndex].tableConfig.page,
          page_rows: 10
        }).then(res => {
          const DATA = res.data
          if (DATA.code == 200) {
            this.$message({
              message: DATA.message,
              type: 'success'
            })
            this.hotelAllDataObj = DATA.data

            this.tableFormLabel[this.tabIndex].tableConfig.total = DATA.data.total
            this.tableFormLabel[this.tabIndex].tableConfig.loading = false
            console.log(this.hotelAllDataObj)
          }

        })
      }

    },
    //住宿订单 详情
    getTourOrderDetail (data) {
      return new Promise(resolve => {
        getTourOrderDetail(data).then((res) => {
          resolve(res)
        })
      })
    },
    //审批退款订单  接口
    AuditHotelOrder (data) {
      return new Promise(resolve => {
        AuditHotelOrder(data).then((res) => {
          const DATA = res.data
          if (DATA.code == 200) {
            this.$message({
              message: DATA.message,
              type: 'success'
            })
            resolve(res)
          } else {
            this.$message({
              message: DATA.message,
              type: 'warning'
            })
          }
        })
      })
    },
    //备注住宿订单  接口
    RemarkHotelOrder (data) {
      return new Promise(resolve => {
        RemarkHotelOrder(data).then((res) => {
          const DATA = res.data
          if (DATA.code == 200) {
            this.$message({
              message: DATA.message,
              type: 'success'
            })
            resolve(res)
          } else {
            this.$message({
              message: DATA.message,
              type: 'warning'
            })
          }
        })
      })
    },
    //获去住宿订单数据详情
    async clickEditData (row) {
      const data = {
        id: row.id
      }

      this.dialogFonfig.isShowDialogVisible = true
      let result = await this.getTourOrderDetail(data)
      let orderInfo = result.data.data.orderInfo
      let price = orderInfo.tour_price_data
      let userInfo = result.data.data.userInfo
      let tourInfo = result.data.data.tourInfo
      let sourceInfo = result.data.data.sourceInfo
      let supplierInfo = result.data.data.supplierInfo
      console.log(result)
      this.openForm = {
        //订单信息
        id: orderInfo.id,
        order_no: orderInfo.order_no,
        order_title: orderInfo.order_title,
        user_id: orderInfo.user_id,
        share_user_id: orderInfo.share_user_id,
        source: orderInfo.source,
        supplier_id: orderInfo.supplier_id,
        tour_id: orderInfo.tour_id,
        tour_days: orderInfo.tour_days,
        tour_adult_num: orderInfo.tour_adult_num,
        tour_kid_num: orderInfo.tour_kid_num,
        departure_date: orderInfo.departure_date,
        departure_city: orderInfo.departure_city,
        departure_site: orderInfo.departure_site,
        tour_price_id: orderInfo.tour_price_id,
        price: price.price,
        cost: price.cost,
        settlement_price: price.settlement_price,
        kid_price: price.kid_price,
        kid_cost: price.kid_cost,
        kid_settlement_price: price.kid_settlement_price,
        integral_price: price.integral_price,
        rate: price.rate,
        kid_rate: price.kid_rate,
        tour_friend_data: orderInfo.tour_friend_data,
        remarks: orderInfo.remarks,
        real_name: orderInfo.real_name,
        mobile: orderInfo.mobile,
        order_type: orderInfo.order_type,
        order_status: orderInfo.order_status,
        total_price: orderInfo.total_price,
        chg_amount: orderInfo.chg_amount,
        real_sum: orderInfo.real_sum,
        balance: orderInfo.balance,
        tour_amount: orderInfo.tour_amount,
        integral: orderInfo.integral,
        cash_coupon_sum: orderInfo.cash_coupon_sum,
        coupon_ids: orderInfo.coupon_ids,
        pay_type: orderInfo.pay_type,
        pay_time: orderInfo.pay_time,
        pay_trade_no: orderInfo.pay_trade_no,
        pay_money: orderInfo.pay_money,
        check_time: orderInfo.check_time,
        finish_time: orderInfo.finish_time,
        cancel_time: orderInfo.cancel_time,
        cancel_reason: orderInfo.cancel_reason,
        refund_time: orderInfo.refund_time,
        refund_money: orderInfo.refund_money,
        refund_reason: orderInfo.refund_reason,
        create_time: orderInfo.create_time,
        admin_id: orderInfo.admin_id,

        // //线路信息
        id: tourInfo.id,
        name: tourInfo.name,
        code_no: tourInfo.code_no,
        product_pic: tourInfo.product_pic,
        travel_mode: tourInfo.travel_mode,
        group_mode: tourInfo.group_mode,
        transport: tourInfo.transport,
        // //渠道来源
        sourceId: sourceInfo.id,
        sourceAbbreviation: sourceInfo.abbreviation,
        sourceNickname: sourceInfo.nickname,
        sourceTelephone: sourceInfo.telephone,
        sourceName: sourceInfo.name,
        sourcePhone: sourceInfo.phone,
        // //供应商信息
        id: supplierInfo.id,
        abbreviation: supplierInfo.abbreviation,
        nickname: supplierInfo.nickname,
        telephone: supplierInfo.telephone,
        name: supplierInfo.name,
        phone: supplierInfo.phone
      }
      // //用户信息
      // name: '',
      // nickname: '',
      // referrer_uid: '',
      // facilitator_id: '',
      // phone: '',
      let arrData = []
      arrData.push(userInfo)
      const priceArray = arrData.map(item => {
        return {
          name: item.name,
          nickname: item.nickname,
          referrer_uid: item.referrer_uid,
          facilitator_id: item.facilitator_id,
          phone: item.phone,
        }
      });

      this.priceDate = this.priceDate.concat(priceArray)
      console.log(this.priceDate)
      var obj = {}
      this.priceDate = this.priceDate.reduce(function (item, next) {
        console.log(item)
        obj[next.facilitator_id] ? '' : obj[next.facilitator_id] = true && item.push(next)
        return item
      }, [])
      console.log(this.priceDate)
    },
    //已退款中的确认
    clickInfoData (row) {
      const data = {
        order_no: row.order_no
      }
      console.log(data)
      this.$confirm('确认这条记录吗？', '提示', { type: "success" }).then(() => {
        const data = {
          order_no: row.order_no
        }
        this.confirmTourOrder(data)
        this.updataTableData()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认'
        });
      })
    },

    //已确认中的 入住按钮操作
    clickImplement (row) {
      const data = {
        order_no: row.order_no
      }
      console.log(data)
      this.$confirm('让这条记录入住吗？', '提示', { type: "success" }).then(() => {
        const data = {
          order_no: row.order_no
        }
        this.implementHotelOrder(data)
        this.updataTableData()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消确认'
        });
      })
    },

    //获得下列分类页的页数
    getPage () {
      // if (this.activeTableName == 'first') {
      //   this.getTourOrder()
      // }
      if (this.searchData) {
        this.searchData.page = this.tableFormLabel[0].tableConfig.page,
          this.getTourOrder(this.searchData)
      } else {
        this.getTourOrder()
      }
    },


    // 数据格式处理
    dataFormatDeal (arr, keyMap, copyInKeyMap) {
      // global 全局方法处理
      return this.globalDeepCloneData(arr, keyMap, copyInKeyMap)
    },

    // 获取最大的 catgory_id值
    MaxCatgroyId (arr, keyMap) {
      let maxid = 0
      for (const val of arr) {
        maxid = maxid > val[keyMap] ? maxid : val[keyMap]
      }
      return maxid
    },


    //切换tab Dialog新增、编辑
    swichTab (tab) {
      const name = tab.name
      this.activeTabName = name
    },
    //确认数据
    clickSubmitData (row) {
      const data = {
        order_no: row.order_no
      }
      console.log(row)
      if (this.activeTabName == 'first') {
        this.activeTabName = 'second'
      } else if (this.activeTabName == 'second') {
        this.activeTabName = 'third'
      } else if (this.activeTabName == 'third') {
        this.activeTabName = 'fourth'
      } else if (this.activeTabName == 'fourth') {
        this.activeTabName = 'fifth'
      } else if (this.activeTabName == 'fifth') {
        this.activeTabName = 'sixth'
      } else if (this.activeTabName == 'sixth') {
        this.dialogFonfig.isShowDialogVisible = false;
      }
    },
    //已支付中 确认订单
    confirmTourOrder (data) {
      confirmTourOrder(data).then(res => {
        const DATA = res.data
        console.log(res)
        if (DATA.code == 200) {
          this.$message.success('确认成功')
        } else {
          this.$message.error('确认失败')
        }
      })
      this.getTourOrder()
    },
    //已确认中 入住订单
    implementHotelOrder (data) {
      implementHotelOrder(data).then(res => {
        const DATA = res.data
        console.log(res)
        if (DATA.code == 200) {
          this.$message.success('确认成功')
        } else {
          this.$message.error('确认失败')
        }
      })
      this.getTourOrder()
    },
    //已支付中，拒绝订单
    clickRefuseData (data) {
      console.log(data)
    },


    //刷新表格数据
    updataTableData () {

      //带审核
      this.getTourOrder();

    },

    // 取消提交数据操作
    clickCancelData () {
      this.activeTabName = "first"
      this.dialogFonfig.isShowDialogVisible = false
      // 用于当前 Vue 实例的初始化选项
      this.openForm = this.$options.data().openForm
      this.dialogFonfigAudit.isShowDialogVisible = false
      this.dialogFonfigRemarks.isShowDialogVisible = false
      // 用于当前 Vue 实例的初始化选项
      this.auditName = this.$options.data().auditName
    },

    // 查询操作
    searchHotelProductToAudit (searchForm) {
      const data = {
        order_status: this.tabIndex,
        order_no: searchForm.order_no,
        order_title: searchForm.order_title,
        user_name: searchForm.username,
        mobile: searchForm.mobile,
        supplier_id: searchForm.supplier_id,
        pay_type: searchForm.pay_type
      }
      console.log(data)
      this.searchData = data
      this.getTourOrder(data)

      console.log(searchForm)
    },
    //重置筛选条件操作
    resetFilter (searchForm) {
      searchForm.order_no = ''
      searchForm.order_title = ''
      searchForm.username = ''
      searchForm.mobile = ''
      searchForm.supplier_id = ''
      searchForm.pay_type = ' '
      this.searchData = ''
      if (this.activeTableName == 'first') {
        this.getTourOrder()
      }
    },

    //切换tab 
    swichTable (tab) {
      this.tabIndex = tab.index
      console.log(this.tabIndex)
      const name = tab.name
      this.activeTableName = name
      if (this.tabIndex == 5 || this.tabIndex == 6) {
        if (this.tabFormLabel[0].children.length == 37) {
          this.tabFormLabel[0].children.push(
            {
              // label: '退款信息  ',
              // width: '500px',
              type: 'text1',
              class: 'refund'
            },
            {
              model: 'refund_time',
              label: '退款时间:',
              width: '356px',
              type: 'text'
            },
            {
              model: 'refund_money',
              label: '退款金额:',
              width: '356px',
              type: 'text'
            },
            {
              model: 'refund_reason',
              width: '700px',
              label: '取消原因:',
              type: 'text'
            },
            {
              model: 'user_id',
              width: '300px',
              label: '管理员ID:',
              type: 'text'
            },
          )
        }
      } else {
        if (this.tabFormLabel[0].children.length > 39) {
          this.tabFormLabel[0].children.splice(37, 5)
        }
      }

      //刷新
      this.updataTableData();
    },

    //审核操作
    clickAuditData (row) {
      this.auditForm = {
        order_no: row.order_no,
        status: row.status,
      }
      console.log(this.auditForm)
      this.dialogFonfigAudit.isShowDialogVisible = true;
    },

    //审核结果提交
    async clickSubmitAuditData (statue, data) {
      // ----------------数据格式-----------------
      //id	是	int	ID
      // status	是	int	状态 3、通过 2、驳回
      const DATA = {
        order_no: data.order_no,
        is_pass: statue,
        remarks: data.remarks
      }
      console.log(DATA)
      await this.AuditHotelOrder(DATA).then(async (res) => {
        if (res.code == 200) {
          await this.updataTableData();
        }
      });//调用审核接口 
      this.dialogFonfigAudit.isShowDialogVisible = false
    },
    //备注操作
    clickRemarks (row) {
      console.log(row)
      this.remarksForm = {
        order_no: row.order_no,
      }
      console.log(this.remarksForm)
      this.dialogFonfigRemarks.isShowDialogVisible = true;
    },
    //提交备注信息
    async clickSubmitRemarksData (data) {
      const DATA = {
        order_no: data.order_no,
        remarks: data.remarks
      }
      console.log(DATA)
      await this.RemarkHotelOrder(DATA).then(async (res) => {
        if (res.code == 200) {
          await this.updataTableData();
        }
      })
      this.dialogFonfigRemarks.isShowDialogVisible = false
    },

  }
}
</script>

<style lang="scss" scoped>
#Manage {
  display: flex;
  display: -webkit-flex;
  // 主轴方向
  flex-direction: column;
  height: 100%;
  .el-transfer {
    text-align: center;
    /deep/ .el-transfer-panel {
      text-align: left;
    }
  }
  .content {
    height: 100%;
  }
  .dialogAudit {
    /deep/ .el-dialog__body {
      padding-right: 45%;
    }
  }
  /deep/ .el-table .cell.el-tooltip {
    white-space: normal;
    text-align: left;
  }
  .filtrateInput {
    background: #f8f7f7;
    padding: 24px 8px;
    // margin-top: 51px;
    width: 100%;
    margin-left: -128px;
    margin-bottom: 32px;
  }
}
/deep/ .el-dialog {
  width: 45%;
  .el-form {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 100%;
    // .el-form-item {
    //   border: 1px solid red;
    //   // width: 70%;
    //   // flex: 0 0 40%;
    //   // margin-left: 20px;
    // }
  }
  .el-form {
    // width: 100%;
  }
}
</style>